import { SEGMENT_EVENTS_SCHEMA_PREFIX } from './event-formatting/constants';

/* Here's a const to make sure our consts stay unique */
export const ANALYTICS = 'CART_ANALYTICS';
/* App-specific action type consts */
export const EDD_LOCATION_CLICKED_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/experience-event/experience/cart/event-type/track/event-name/estimated-delivery-date-information-clicked/version/LATEST/schema.json`;

export const OUT_OF_STOCK_MESSAGE_SHOWN_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/experience-event/experience/cart/event-type/track/event-name/out-of-stock-message-shown/version/LATEST/schema.json`;

export const LOW_INVENTORY_MESSAGE_SHOWN_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/experience-event/experience/cart/event-type/track/event-name/low-inventory-message-shown/version/LATEST/schema.json`;

export const PICKUP_INFORMATION_CLICKED_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/experience-event/experience/cart/event-type/track/event-name/pickup-information-clicked/version/LATEST/schema.json`;

/* Tooltip types for analytics */
export const TOOLTIP_EST_SHIPPING = `${ANALYTICS}/TOOLTIP/EST_SHIP_&_HANDLING`;
export const TOOLTIP_EST_TAX = `${ANALYTICS}/TOOLTIP/EST_TAX`;
export const TOOLTIP_SUBTOTAL = `${ANALYTICS}/TOOLTIP/SUBTOTAL`;

export const CHECKOUT_INTENT_START = 'Checkout Intent Start';
export const CHECKOUT_INTENT_START_EVENT_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/core-buy-flow/experience/cart/event-type/track/event-name/checkout-intent-start/version/LATEST/schema.json`;

export const ACCOUNT_AUTHENTICATED_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/core-buy-flow/experience/cart/event-type/track/event-name/account-authenticated`;
export const ACCOUNT_CREATED_SCHEMA = `${SEGMENT_EVENTS_SCHEMA_PREFIX}/core-buy-flow/experience/cart/event-type/track/event-name/account-created`;

export const CHANGE_VIEW = 'changeView';

export const CLASSIFICATION_CORE_BUY_FLOW = 'core buy flow';
